import { Component, input } from '@angular/core';

let nextBrandId = 0;

@Component({
    selector: 'app-brand-logo',
    template: `
        @if (compact()) {
            <img src="/brand/favicon.svg" alt="GetAudit" width="32" height="32" class="brand-icon" [class]="imageClass()" />
        } @else {
            <svg viewBox="653 348 1094 264" width="180" height="44" role="img" aria-label="GetAudit" class="brand-wordmark" [class]="imageClass()" [class.brand-wordmark-inverse]="inverse()">
                @if (inverse()) {
                    <defs>
                        <filter [attr.id]="filterId" color-interpolation-filters="sRGB">
                            <feColorMatrix type="luminanceToAlpha" />
                            <feComponentTransfer>
                                <feFuncA type="linear" slope="-1.1" intercept="1.1" />
                            </feComponentTransfer>
                        </filter>
                        <mask [attr.id]="maskId" maskUnits="userSpaceOnUse" x="960" y="348" width="787" height="264" style="mask-type: alpha">
                            <image href="/brand/logo-horizontal.png" width="2400" height="960" [attr.filter]="'url(#' + filterId + ')'" />
                        </mask>
                    </defs>
                    <image href="/brand/favicon.svg" x="667" y="360" width="240" height="240" />
                    <rect x="960" y="348" width="787" height="264" fill="#fff" [attr.mask]="'url(#' + maskId + ')'" />
                } @else {
                    <image href="/brand/logo-horizontal.png" width="2400" height="960" />
                }
            </svg>
        }
    `,
    styles: `
        :host {
            display: contents;
        }

        .brand-wordmark {
            display: inline-block;
            width: 180px;
            max-width: 100%;
            height: auto;
            overflow: hidden;
            vertical-align: middle;
            border-radius: 0.375rem;
            background: #fff;
        }

        .brand-icon {
            width: 32px;
            height: 32px;
            vertical-align: middle;
        }

        .brand-wordmark-inverse {
            border-radius: 0;
            background: transparent;
        }
    `
})
export class BrandLogoComponent {
    readonly compact = input(false);
    readonly inverse = input(false);
    readonly imageClass = input('');

    // Each logo owns its SVG references, including when the mobile logo is hidden.
    private readonly instanceId = nextBrandId++;
    protected readonly filterId = `brand-ink-${this.instanceId}`;
    protected readonly maskId = `brand-wordmark-${this.instanceId}`;
}
